import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild, NgZone, OnDestroy } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { AuthenticationService } from 'src/app/security/authentication.service';
import { TenantModel } from 'src/app/models/tenant-mstr.model';
import { environment } from '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VersionHistoryModalComponent, VersionItem } from '../modals/version-history-modal/version-history-modal.component';
import { ClauseEditModalComponent } from '../modals/clause-edit-modal/clause-edit-modal.component';
import { AlertService } from 'src/app/services/alert.service';
import { TranslatePipe } from 'src/app/pipes/translate.pipe';
import { DeleteModalComponent } from '../modals/delete/delete.component';
import { timeout } from 'rxjs/operators';
interface Message {
  text: string;
  isUser: boolean;
  isLast: boolean;
}

@Component({
  selector: 'app-chatbot-content',
  templateUrl: './chatbot-content.component.html',
  styleUrls: ['./chatbot-content.component.scss']
})
export class ChatbotContentComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;

  messages: Message[] = [];
  newMessage: string = '';
  sending: boolean = false;
  isLoading: boolean = false;
  thinking: string = '';
  private isUserScrolling: boolean = false;
  private previousMessagesLength: number = 0;
  public tenantObject!: TenantModel;
  modalRef: any;
  editModalRef: any;
  generatedVersions: VersionItem[] = [];
  private documentGenerated: boolean = false;

  preferDocx: boolean = false;
  userLoggedIn: any;

  constructor(
    public apiService: ApiService,
    private ngZone: NgZone,
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private alertService: AlertService,
    private translate: TranslatePipe
  ) { }

  ngOnInit(): void {
    try {
      this.userLoggedIn = this.authService.getLoggedInUser();
      this.tenantObject = this.authService.getTenant();
    } catch {
      this.tenantObject = {} as TenantModel;
    }

    const botMessage: Message = { text: 'Describe the contract you want to generate:', isUser: false, isLast: false };
    this.messages.push(botMessage);
    this.sending = false;

    setTimeout(() => {
      if (this.messagesContainer) {
        this.messagesContainer.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
      }
    }, 0);

    this.previousMessagesLength = this.messages.length;
  }

  ngAfterViewChecked(): void {
    if (!this.isUserScrolling && this.messages.length > this.previousMessagesLength) {
      this.scrollToBottom();
    }
    this.previousMessagesLength = this.messages.length;
  }

  ngOnDestroy(): void {
  }

  formatResponse(botMessage: string): string {
    if (!botMessage) return '';

    let text = botMessage.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    const indexRegex = /^(?:\s*)(ÍNDICE|INDICE|INDEX|CONTENTS|TABLE OF CONTENTS)\s*$/gim;
    const match = indexRegex.exec(text);
    let indexSection = '';

    if (match) {
      const start = match.index + match[0].length;
      const afterIndex = text.slice(start).trim();

      const lines = afterIndex.split('\n').map(l => l.trim()).filter(l => l.length > 0);

      const indexLines: string[] = [];
      for (const line of lines) {
        if (/^(?:\d+(\.\d+)*\.?|[IVXLC]+\.|[A-Z]\)|Artículo\s+\d+)/.test(line)) {
          indexLines.push(line.replace(/\.+\s*\d*\s*$/g, '').trim());
        } else if (indexLines.length > 0) {
          break;
        }
      }
      indexSection = indexLines.join('\n');
    } else {
      const lines = text.split('\n').map(l => l.trim()).filter(l => l.length > 0);
      const numbered = lines.filter(l =>
        /^(?:\d+(\.\d+)*\.?|[IVXLC]+\.|[A-Z]\)|Artículo\s+\d+)/.test(l)
      );
      indexSection = numbered.join('\n');
    }

    let formattedMessage = indexSection.replace(/\n/g, '<br>');
    formattedMessage = formattedMessage.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    formattedMessage = formattedMessage.replace(/\*(.*?)\*/g, '<em>$1</em>');

    if (formattedMessage) {
      this.documentGenerated = true;
      formattedMessage = 'Contract generated successfully with the following clauses:<br><br>' + formattedMessage;
    }

    return formattedMessage || text;
  }


  private scrollToBottom(): void {
    try {
      this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
    } catch (err) {
      console.error('Error al hacer scroll:', err);
    }
  }

  onScroll(): void {
    const element = this.messagesContainer.nativeElement;
    this.isUserScrolling = element.scrollTop + element.clientHeight !== element.scrollHeight;
  }
  public async editClause(version: VersionItem) {
    if (!version) return;
    this.editModalRef = this.modalService.open(ClauseEditModalComponent, { size: 'xl', centered: true });
    this.editModalRef.componentInstance.isLoading = true;
    this.editModalRef.componentInstance.baseVersion = version.updated_at ? version.updated_at : '1';
    this.editModalRef.componentInstance.companyId = String(this.tenantObject.tenantid);
    this.apiService
      .get('content_generator/contracts/' + version.id + '/clauses', { 'company_id': String(this.tenantObject.tenantid), 'tenant_name': this.tenantObject.tenantname }, false, false, {}, '', false)
      .subscribe(
        (response) => {
          this.editModalRef.componentInstance.versionData = response.clauses;
          this.editModalRef.componentInstance.isLoading = false;
          setTimeout(() => {
            const modalComponent = this.editModalRef.componentInstance as any;
            if (modalComponent.ngOnChanges) {
              modalComponent.ngOnChanges({
                versionData: {
                  clause: response.clauses,
                  previousValue: [],
                  firstChange: false,
                  isFirstChange: () => false,
                },
              });
            }
          });
          this.editModalRef.componentInstance.dataChanged.subscribe(result => {
            this.SaveNewVersion(result);
          })
        },
        (error) => {
          console.log(error);
        }
      )
  }

  public async SaveNewVersion(newClauseData: any) {
    this.modalRef.close();
    if (!newClauseData) return;
    newClauseData = { ...newClauseData, tenant_name: this.tenantObject.tenantname };
    this.apiService
      .post('content_generator/contracts/edit', newClauseData, '', true, {}, false)
      .subscribe(
        (response) => {
          this.editModalRef.close();
          this.alertService.success(
            this.translate.transform(
              'documentInfo.editedDocument'
            ),
            true
          );
        },
        (error) => {
          this.ngZone.run(() => { });
          console.log(error);
        })

  }
  public async downloadVersion(version: VersionItem) {
    if (!version) return;

    const headers = {
      [environment.tokenHeader]: this.authService.getToken()
    }

    this.apiService
      .get_download_file('content_generator/contracts/' + (version.id).toString() + '/v/' + (version['current_version']).toString() + '/download/docx', { 'company_id': String(this.tenantObject.tenantid), 'tenant_name': this.tenantObject.tenantname }, '', headers, false)
      .subscribe(
        (response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers ? response.headers.get('Content-Disposition') : null;
          let filename = 'archivo.docx';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              filename = match[1];
            }
          }

          const body = response.body;
          const blob = body instanceof Blob
            ? body
            : new Blob([body as any], {
              type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();

          window.URL.revokeObjectURL(url);

          this.modalRef.close();
          this.alertService.success(
            this.translate.transform(
              'consolidation.downloadFile.successdownload'
            ),
            true
          );
        },
        (error) => {
          this.alertService.error(
            this.translate.transform(
              'validation.downloadFile.unsuccessdownload'
            ),
            true
          );
        }
      )
  }


  public removeVersion(versionId: string, listcontract: VersionItem[]) {
    const modalWindowRef = this.modalService.open(DeleteModalComponent, { backdrop: 'static', keyboard: false, centered: true, size: 'sm' });
    modalWindowRef.componentInstance.options = { type: 'document', notAllowed: versionId.length < 1 };
    modalWindowRef.result.then(
      result => {
        if (result === 1) {
          this.modalRef.componentInstance.isLoading = true;
          this.apiService.put('content_generator/contracts/' + versionId + '/deactivate', '', {}, '', true, { params: { company_id: String(this.tenantObject.tenantid), tenant_name: this.tenantObject.tenantname } }, false)
            .subscribe((response: any) => {
              console.log(response)
              this.modalRef.componentInstance.isLoading = false;
              listcontract = listcontract.filter(v => v.id !== versionId);
              this.modalRef.componentInstance.versions = listcontract;
              this.alertService.success(
                this.translate.transform(
                  'consolidation.sendDeleteRequestsuccess'
                ),
                true
              );
            }, (error) => {
              this.ngZone.run(() => {
                console.error(error);
                this.alertService.error(
                  this.translate.transform(
                    'consolidation.sendDeleteRequestunsuccess'
                  ),
                  true
                );
              });
            });

        }
      },
      reason => {
        console.log('Reason ' + reason);
      }
    );
    //
  }

  send(): void {
  this.sending = true;
  if (this.newMessage.trim() === '') {
    this.sending = false;
    return;
  }

  const userMessage: Message = { text: this.newMessage, isUser: true, isLast: true };
  this.messages.push(userMessage);
  const lastUserMessage = this.messages[this.messages.length - 1];

  const payload = { user_id: String(this.userLoggedIn['userid']), company_id: String(this.tenantObject.tenantid), message: this.newMessage, tenant_name: this.tenantObject.tenantname };

  //const botMessage: Message = { text: this.translate.transform('components.loading.generatingContract'), isUser: false, isLast: true };
  //this.messages.push(botMessage);
  this.newMessage = '';

  let accumulated = '';
  let lastPartialLength = 0;

  this.apiService.post('content_generator/chat/stream', payload, '', true, { responseType: 'text', observe: 'events', reportProgress: true }, false)
    .subscribe((event: any) => {

      if (event?.partialText) {
        const newChunk = event.partialText.slice(lastPartialLength);
        lastPartialLength = event.partialText.length;

        for (const line of newChunk.split('\n')) {
          if (line.startsWith('data: ')) {
            const data = line.slice(6).trim();
            if (data === '[DONE]') continue;
            try {
              const parsed = JSON.parse(data);
              if (parsed.content) {
                accumulated += parsed.content;

                const contentStarted = /\*\*\d+\.|\bREUNIDOS\b/.test(accumulated);

                if (contentStarted) {
                  const headings = accumulated
                    .split('\n')
                    .filter(l => /^\*\*\d+\.\s+[^\d*]/.test(l.trim()))
                    .map(l => l.trim().replace(/\*\*/g, ''))
                    .filter((v, i, arr) => arr.indexOf(v) === i)
                    .join('<br>');
				this.thinking= this.translate.transform('components.modal.loading.generatingContract') + (headings);
                  this.ngZone.run(() => {
                    //botMessage.text = headings || this.translate.transform('components.loading.generatingContract');
                  });
                }
              }
            } catch { /* chunk parcial */ }
          }
        }
      }
 if (event?.type === 4) {
lastUserMessage.isLast = false;
      	// botMessage.isLast = false;
        //botMessage.text = this.formatResponse(accumulated);
if (this.documentGenerated) {
          this.openVersionHistoryWith();
        }
        this.ngZone.run(() => { this.sending = false; });
      }

    }, (error) => {
      this.ngZone.run(() => {
        lastUserMessage.isLast = false;
       // this.messages = this.messages.filter(m => m !== botMessage);
        this.sending = false;
        console.error('POST /chat/stream error', error);
 });
    });
}



  public openVersionHistoryWith() {
    this.isLoading = true
    this.modalRef = this.modalService.open(VersionHistoryModalComponent, { size: 'xl', centered: true, backdrop: 'static', keyboard: false });
    this.modalRef.componentInstance.versions = '';
    this.modalRef.componentInstance.isLoading = true;
    this.modalRef.componentInstance.allowEdit = true;

    this.apiService
      .get('content_generator/contracts', { 'company_id': String(this.tenantObject.tenantid), tenant_name: this.tenantObject.tenantname }, false, false, {}, '', false)
	  .pipe(timeout(600000))
      .subscribe(
        (response) => {
          this.modalRef.componentInstance.isLoading = false;
          const list: VersionItem[] = Array.isArray(response.contracts) ? response.contracts : [response.contracts];
          this.modalRef.componentInstance.versions = list;
          this.modalRef.componentInstance.removeCallback = (contract: VersionItem) => {
            this.removeVersion(contract.id, list);
          };
          this.modalRef.componentInstance.dataChanged.subscribe(result => {
            console.log(result)
            if (!result) return;
            if (result && result.action === 'download' && result.version) {
              this.downloadVersion(result.version);
            } else if (result && result.action === 'edit' && result.version) {
              this.editClause(result.version);
            }
          })
        },
        (error) => {
          this.ngZone.run(() => {
            console.log(error);
          });
        }
      )
  }

  cleanChat(): void {
    this.messages = [];
    this.previousMessagesLength = 0;
  }
}